"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
class Profile {
    constructor(userRepository) {
        this.changePassword = async (oldPassword, newPassword) => {
            try {
                const user = await this.getUserByToken(await this.tokenService.getValidToken());
                if (user.password !== oldPassword) {
                    throw new exception_1.DomainException("Bad Credentials");
                }
                user.password = newPassword;
                await this.userRepository.putUser(user);
            }
            catch (e) {
                throw new exception_1.DomainException("Request failed", e);
            }
        };
        this.getUserByToken = async (token) => {
            return this.userRepository.getUserByToken(token);
        };
        this.userRepository = userRepository;
    }
    setTokenService(tokenService) {
        this.tokenService = tokenService;
    }
    requestPasswordChange() {
        return Promise.resolve();
    }
}
exports.default = Profile;
//# sourceMappingURL=Profile.js.map